import { baseStoreCreator } from '@/utils/store';

interface HealthPlanSpendTrackerStorePayload {
  coverageLevel: string;
  healthPlanId?: string;
}

export const DEFAULT_VALUES: HealthPlanSpendTrackerStorePayload = {
  coverageLevel: '',
  healthPlanId: ''
};

export const useHealthPlanSpendTrackerStore = baseStoreCreator<HealthPlanSpendTrackerStorePayload>(DEFAULT_VALUES);

export default useHealthPlanSpendTrackerStore;
